(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const footerHeadings = document.querySelectorAll('.t4s-footer-heading-mobile');
  
  // Ensure "Get in touch" is always open and has the class
  footerHeadings.forEach(h => {
     const title = h.querySelector('h3').textContent.trim().toLowerCase();
     if (title.includes('get in touch') || title.includes('contato')) {
        const p = h.closest('.t4s-col-inner');
        if (p) {
          p.classList.add('is--footer_opened');
          const c = p.querySelector('[data-footer-content]');
          if (c) c.style.display = 'block';
          h.style.pointerEvents = 'none'; // Disable clicking
          const icon = h.querySelector('.t4s-footer-collapse-icon');
          if (icon) icon.style.display = 'none'; // Hide accordion icon as it doesn't toggle
        }
     }
  });

  footerHeadings.forEach(heading => {
    heading.addEventListener('click', function() {
      const parent = this.closest('.t4s-col-inner');
      const isCollapse = document.querySelector('.t4s-footer-wrap').classList.contains('is--footer-collapse-true');
      const title = this.querySelector('h3').textContent.trim().toLowerCase();
      
      // Don't toggle if it's Get in touch
      if (title.includes('get in touch') || title.includes('contato')) return;

      if (parent && isCollapse) {
        parent.classList.toggle('is--footer_opened');
        const content = parent.querySelector('[data-footer-content]');
        if (content) {
          if (parent.classList.contains('is--footer_opened')) {
            content.style.display = 'block';
          } else {
            content.style.display = 'none';
          }
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
